export type SessionUser = {
  id: string;
  email: string;
  full_name: string;
  phone?: string;
  role: 'admin' | 'employee';
  employee_id?: string;
};

export type Session = { token: string; user: SessionUser };

const SESSION_KEY = 'rastamen_session';

export function getSession(): Session | null {
  try {
    return JSON.parse(localStorage.getItem(SESSION_KEY) || sessionStorage.getItem(SESSION_KEY) || 'null');
  } catch {
    return null;
  }
}

// remember=true → kalıcı (localStorage, tarayıcı kapansa da kalır); false → geçici (sessionStorage, sekme kapanınca silinir)
export function setSession(session: Session | null, remember = true) {
  localStorage.removeItem(SESSION_KEY);
  sessionStorage.removeItem(SESSION_KEY);
  if (session) (remember ? localStorage : sessionStorage).setItem(SESSION_KEY, JSON.stringify(session));
}

export async function api<T>(path: string, options: RequestInit = {}): Promise<T> {
  const session = getSession();
  const response = await fetch(`/api${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(session?.token ? { Authorization: `Bearer ${session.token}` } : {}),
      ...options.headers,
    },
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || 'İşlem tamamlanamadı.');
  return data as T;
}

export async function uploadFile<T>(path: string, file: File): Promise<T> {
  const session = getSession();
  const body = new FormData();
  body.append('photo', file);
  const response = await fetch(`/api${path}`, {
    method: 'POST',
    headers: session?.token ? { Authorization: `Bearer ${session.token}` } : {},
    body,
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) throw new Error(data.message || 'Fotoğraf yüklenemedi.');
  return data as T;
}

export const money = (value: number | string) =>
  new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(Number(value || 0));

export const dateLabel = (value: string) =>
  new Intl.DateTimeFormat('tr-TR', { day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(`${value.slice(0, 10)}T12:00:00`));
